import routerOptions0 from "/app/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  linkExactActiveClass: "active",
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}